import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from '@app/shell/footer/footer.component';

@Component({
  selector: 'zero-waste-public-shell',
  standalone: true,
  imports: [RouterOutlet, FooterComponent],
  templateUrl: './public-shell.component.html',
  styleUrls: ['./public-shell.component.scss'],
})
export class PublicShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
